<template>
    <div class="col-4 mb-3 pr-0">
        <div class="my-card-numbers">
            <div class="my-card-numbers-icon">
                <i class="bx bx-bar-chart-alt"></i>
            </div>
            <div>
                <h4>{{ values.total }}%</h4>
                <p class="title">{{ label }}</p>
                <p>{{ sublabel }}</p>
            </div>
            <div class="text-right">
                <h4> {{ values.anterior }}%</h4>
                <p class="mb-0 color-gray">Mês anterior</p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        values: {
            type: [Array, Object],
            required: true
        },
        label: {
            type: String,
            required: true
        },
        sublabel: {
            type: String,
            required: false
        }
    },
};
</script>
<style>
.sublabel {
    height: 26px;
    display: flex;
    align-items: center;
    align-content: center;
}

.sublabel p {
    margin: 0 auto
}
</style>